<template>
    <div class="card">
        <div class="card-content">
            <div class="field has-addons">
                <div class="control is-expanded">
                    <div class="select is-fullwidth">
                        <select id="favoriteSearch" v-model="favoriteSearch">
                            <option value="" selected disabled>Select your favorite search</option>
                            <option v-for="search in searches" :value="search.search">{{ diffSearchForHumans(search.search) }}</option>
                        </select>
                    </div>
                </div>
                <div class="control">
                    <button class="button is-info" @click="selectFavoriteSearch">
                        Search
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import apiFavoriteSearches from './../../../api/apiFavoriteSearches'
    export default {
        data() {
            return {
                favoriteSearch: ''
            }
        },
        methods: {
            selectFavoriteSearch() {
                this.$store.dispatch('setQueryToNewValue', JSON.parse(this.favoriteSearch))
                this.$store.dispatch('fetchResults')
            },
            diffSearchForHumans(search) {
                let output = ''
                let raw = Object.values(JSON.parse(search))
                let labels = Object.keys(JSON.parse(search))
                raw.forEach(function (element, index) {
                    if (element !== null){
                        if (element.length > 0) {
                            let label = labels[index].replace(/_/g, " ").toLowerCase()
                            let value = JSON.stringify(element).replace(/_/g, " ").toUpperCase()
                            output += label +': ' + value + ', '
                        }
                    }
                })
                return output
            }
        },
        computed: {
            searches() {
                return this.$store.getters.getFavoriteSearches
            }
        },
        created() {
            apiFavoriteSearches
                .favoriteSearchesListRequest()
                .then((response) => {
                    this.$store.dispatch('setFavoriteSearches', response.data)
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
</script>

<style scoped>
    .card {
        margin-bottom: 25px;
    }
    input:focus {
        outline:none;
    }

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Results/FavoriteSearches.vue